const pt = {
  today: "Jogos de Hoje",
  live: "AO VIVO",
  upcoming: "Próximos",
  stats: "Estatísticas",
  noLive: "Nenhum jogo ao vivo agora",
  clickForStats: "Clique para estatísticas completas",
  viewOdds: "Ver Odds ao Vivo →",
  headToHead: "Confronto Direto",
  form: "Forma Atual",
  goalStats: "Estatísticas de Gols",
  leagueTable: "Tabela da Liga",
  injuries: "Lesões e Suspensões",
  outcome: "Resultado Provável",
  homeWin: "Vitória em Casa",
  draw: "Empate",
  awayWin: "Vitória Fora",
  confidence: "Confiança",
  viewing: "pessoas assistindo",
  subscribe: "Receba Análises Semanais Grátis",
  subscribeDesc: "Toda sexta — Top 5 jogos com estatísticas.",
  yourEmail: "Seu email",
  subscribe_btn: "Assinar Grátis",
  worldCup: "Copa do Mundo FIFA 2026",
  daysAway: "dias restantes",
  viewQualifiers: "Ver Eliminatórias",
  featuredMatches: "🔥 Grandes Jogos",
  favourite: "Times Favoritos",
  addFav: "Adicionar aos favoritos",
  removeFav: "Remover dos favoritos",
  kickoff: "Início",
  stadium: "Estádio",
  season: "Prévia da Temporada",
  loading: "Carregando jogos...",
  avgScored: "Média de Gols",
  avgConceded: "Média Sofrida",
};
export default pt;